var React = require('react');

function ArrowPrevInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23.9092 14.9766L27.3091 18.6856L23.9092 22.3946","stroke":"white","key":0}),React.createElement("path",{"d":"M27.3084 18.6835L9.69043 18.6836","stroke":"white","key":1}),React.createElement("circle",{"cx":"18.5","cy":"18.5","r":"18.0595","stroke":"white","strokeWidth":"0.880952","key":2})]);
}

ArrowPrevInline.defaultProps = {"width":"37","height":"37","viewBox":"0 0 37 37","fill":"none"};

module.exports = ArrowPrevInline;

ArrowPrevInline.default = ArrowPrevInline;
